import { render, staticRenderFns } from "./PrintersCard.vue?vue&type=template&id=1b9e0e3a&scoped=true"
import script from "./PrintersCard.vue?vue&type=script&lang=js"
export * from "./PrintersCard.vue?vue&type=script&lang=js"
import style0 from "./PrintersCard.vue?vue&type=style&index=0&id=1b9e0e3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9e0e3a",
  null
  
)

export default component.exports